import type { SVGProps } from "react";
import * as React from "react";
const SvgMistral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#FEFAEC" rx={4} />
    <path
      fill="#1A1C20"
      d="M5 5.5h.977v13H5zM15.419 13.3h.977v5.2h-.977zM12.814 8.1h.977v2.6h-.977zM10.209 13.3h.977v2.6h-.977zM15.419 5.5h.977v2.6h-.977z"
    />
    <path
      fill="#FFCD00"
      d="M5.977 5.5h2.605v2.6H5.977zM16.395 5.5H19v2.6h-2.605z"
    />
    <path
      fill="#FFA301"
      d="M5.977 8.1h2.605v2.6H5.977zM16.395 8.1H19v2.6h-2.605z"
    />
    <path
      fill="#FFA301"
      d="M8.581 8.1h2.605v2.6H8.581zM13.791 8.1h2.605v2.6h-2.605z"
    />
    <path
      fill="#FF6F00"
      d="M5.977 10.7h2.605v2.6H5.977zM16.395 10.7H19v2.6h-2.605z"
    />
    <path
      fill="#FF6F00"
      d="M8.581 10.7h2.605v2.6H8.581zM13.791 10.7h2.605v2.6h-2.605zM11.186 10.7h2.605v2.6h-2.605z"
    />
    <path
      fill="#FF4606"
      d="M5.977 13.3h2.605v2.6H5.977zM16.395 13.3H19v2.6h-2.605zM11.186 13.3h2.605v2.6h-2.605z"
    />
    <path
      fill="#FF0107"
      d="M5.977 15.9h2.605v2.6H5.977zM16.395 15.9H19v2.6h-2.605z"
    />
  </svg>
);
export default SvgMistral;
